import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { closeEditPerson, closeEditZone } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { handleError } from 'reducers/ErrorReducer';
import Sops from './Sops';
import Attachments from 'components/Attachments';
import { getZoneSops } from 'reducers/SearchReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';
const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  content: {
    margin: -theme.spacing(3),
  },
  RedTabs: {
    color : 'red'
  }
}));

function Zone(props) {
  const classes = useStyles();
  const { data } = props;
  const { ZoneCode, IntCode } = data;
  const [tab, setTab] = useState('sops');
  const mountedRef = useRef(true);
  const [countOfSops, setCountOfSops] = useState(0);
  const permissions = getFullPermissions('globals', 'Zones', 'any');
  //const newAddress = !ptsPersonID;
  useEffect(() => {
    if (props.tab) setTab(props.tab);
    if(ZoneCode){
      getSOPs();
    }

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, [props.tab]);

  const close = (data) => {
    //props.closeEditPerson(data);
    props.closeEditZone();
  };

  const getSOPs = async () => {
    try {
      const sops = await getZoneSops(IntCode);
      if (!mountedRef.current) return;
      setCountOfSops(processSOPData(sops.data).length);
    } catch (err) {
      props.handleError(err, 'Error receiving zone sops data.');
    }
  };
  const processSOPData = (data) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: row.ptsSOPID,
      };
    });
  };

  const handleSOPChange = (newCount) => {
    setCountOfSops(newCount);
  };

  const getTitle = () => {
    const title = !ZoneCode ? 'Add Zone' : 'Edit Zone';
    return  permissions.Edit ? (
      `${title}`
    ) : (
      <div className="d-flex" style={{ width: '100%', justifyContent: 'left', textAlign: 'left' }}>
        <span style={{ flex: 0.5 }}></span>
        <span style={{ flex: 0.5, color: 'red', fontWeight: 'bold', fontSize: '21px' }}>
          VIEW ONLY MODE
        </span>
      </div>
    );
  };
  return (
    <Dialog toolbar onClose={close} title={getTitle()} fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs variant="scrollable" value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label={countOfSops > 0 ? `SOPs (${countOfSops})` : 'SOPs'} value="sops" className={countOfSops > 0 ? classes.RedTabs : ''} />
            <Tab label="Attachments" value="attachments" />

            {/* <Tab label="Coordinates" value="coordinates" /> */}
          </Tabs>
        </Paper>

        {tab === 'sops' && <Sops IntCode={IntCode} onSOPChange={handleSOPChange} />}
        {tab === 'attachments' && <Attachments type="Zone" id={IntCode} permissions= {permissions} />}
      </div>
    </Dialog>
  );
}

export default connect(null, {
  closeEditPerson,
  handleError,
  closeEditZone,
})(Zone);
